import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';
import { AUTO_COMPLETE_DEFAULT, TEXT_FIELD_TYPE_PASSWORD } from '../../utilities/FormUtilities';
import NgpTextField from './NgpTextField';

export default function NgpPasswordField(props) {
    const { inputProps, fieldName } = props;
    const {
        setValue,
        formState: { dirtyFields },
    } = useFormContext();

    const handlePasswordFieldClick = useCallback(() => {
        // If the password field is not dirty, that means we probably loaded
        //  it with our temp password, clear it out so they can create a new one.
        if (!get(dirtyFields, fieldName)) {
            setValue(fieldName, '');
        }
    }, [fieldName, dirtyFields, setValue]);

    const theInputProps = useMemo(() => ({ ...inputProps, autoComplete: AUTO_COMPLETE_DEFAULT }), [inputProps]);
    return (
        <NgpTextField
            {...props}
            fieldType={TEXT_FIELD_TYPE_PASSWORD}
            inputProps={theInputProps}
            onClick={handlePasswordFieldClick}
        />
    );
}
